import type { RawElementInfo } from '@viewer/lib/ifcRawParse'

export default function RawRepresentationView({
  raw,
}: {
  raw: RawElementInfo | null
}) {
  return (
    <div className="space-y-2 text-[11px]">
      {!raw ? (
        <div className="px-1 py-2 text-[11px] italic text-[var(--color-text-muted)]">
          A ler IFC paralelo via web-ifc…
        </div>
      ) : raw.representations.length === 0 ? (
        <div className="rounded border border-[var(--color-border)]/40 bg-[var(--color-bg)]/30 px-2 py-1 text-[11px] italic text-[var(--color-text-muted)]">
          Sem IfcProductDefinitionShape declarado para esta entidade.
        </div>
      ) : (
        <div className="space-y-2">
          {raw.hasMappedRepresentation && (
            <div className="rounded border border-emerald-700/50 bg-[var(--color-ok-bg)] px-2 py-1.5 text-[11px] text-emerald-100">
              <div className="text-[10px] uppercase tracking-wide text-emerald-400/90">
                MappedRepresentation
              </div>
              Geometria reutilizada via IfcRepresentationMap, instanciamento
              geométrico real (a mesma geometria pode ser partilhada por
              várias instâncias).
            </div>
          )}
          {raw.representations.map((r, i) => (
            <div
              key={`${r.identifier}-${i}`}
              className="rounded border border-[var(--color-border)]/60 bg-[var(--color-bg)]/40"
            >
              <div className="flex items-center justify-between border-b border-[var(--color-border)]/60 px-2 py-1">
                <span className="font-mono text-[var(--color-text)]">
                  {r.identifier || '(sem identifier)'}
                </span>
                <span className="text-[10px] uppercase text-[var(--color-text-muted)]">
                  {r.type}
                </span>
              </div>
              {r.contextType && (
                <div className="px-2 pt-1 text-[10px] text-[var(--color-text-muted)]">
                  ContextOfItems: {r.contextType}
                </div>
              )}
              <ul className="px-2 py-1 space-y-1">
                {r.items.map((it, j) => (
                  <li
                    key={`${it.type}-${j}`}
                    className="rounded bg-[var(--color-surface)]/60 px-2 py-1"
                  >
                    <div className="flex items-center justify-between">
                      <span className="font-mono text-[var(--color-text)]">
                        {it.type}
                      </span>
                      {it.expressID !== null && (
                        <span className="text-[10px] text-[var(--color-text-dim)]">
                          #{it.expressID}
                        </span>
                      )}
                    </div>
                    {it.detail && (
                      <div className="mt-0.5 text-[10px] text-[var(--color-text-muted)]">
                        {it.detail}
                      </div>
                    )}
                    {it.isMapped && (
                      <div className="mt-0.5 inline-block rounded bg-[var(--color-ok-bg)] px-1.5 py-0.5 text-[10px] text-[var(--color-ok-text)]">
                        IfcMappedItem
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
